import React, { useState, useEffect } from 'react';
import { Button, Typography, Box, Stack, Alert } from '@mui/material';
import { ArrowForward, Bookmark, BookmarkBorder, CheckCircleOutline, HighlightOff } from '@mui/icons-material';

function QuestionCard({ question, onAnswer, onToggleSaved, isSaved = false }) {
  const [selected, setSelected] = useState(null);
  const [answered, setAnswered] = useState(false);
  const correctIndex = question.correctAnswer;

  useEffect(() => {
    setSelected(null);
    setAnswered(false);
  }, [question]);

  const handleClick = (index) => {
    if (answered) return;
    setSelected(index);
    setAnswered(true);
  };

  const handleNext = () => {
    onAnswer(selected === correctIndex);
  };

  const getButtonVariant = (index) => {
    if (!answered) {
      return selected === index ? 'contained' : 'outlined';
    }
    if (index === correctIndex) {
      return 'contained';
    }
    return 'outlined';
  };

  const getButtonColor = (index) => {
    if (!answered) {
      return 'primary';
    }
    if (index === correctIndex) {
      return 'success';
    }
    if (index === selected) {
      return 'error';
    }
    return 'primary';
  };

  return (
    <Stack spacing={2}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 1 }}>
        <Typography variant="h4" component="h2" sx={{ lineHeight: 1.32, fontSize: { xs: '1.4rem', md: '1.7rem' } }}>{question.question}</Typography>
        {onToggleSaved && <Button onClick={onToggleSaved} startIcon={isSaved ? <Bookmark /> : <BookmarkBorder />} variant="text" aria-label={isSaved ? 'Usuń zapis pytania' : 'Zapamiętaj pytanie'} sx={{ flexShrink: 0, color: 'primary.main', minWidth: 0 }}>
          {isSaved ? 'Zapisane' : 'Zapamiętaj'}
        </Button>}
      </Box>
      {question.image && (
        <Box
          sx={{
            mt: 1,
            mb: 1,
            p: 2,
            borderRadius: 1,
            border: '1px solid rgba(36,91,89,0.12)',
            backgroundColor: 'rgba(246,248,245,.8)',
            textAlign: 'center',
          }}
        >
          <img
            src={`/assets/${question.image}`}
            alt="question illustration"
            style={{ maxWidth: '100%', maxHeight: 350, height: 'auto' }}
          />
        </Box>
      )}
      <Stack spacing={1}>
        {question.answers.map((opt, i) => (
          <Button
            key={i}
            onClick={() => handleClick(i)}
            variant={getButtonVariant(i)}
            color={getButtonColor(i)}
            disabled={answered && selected !== i && i !== correctIndex}
            fullWidth
            sx={{
              justifyContent: 'flex-start',
              textAlign: 'left',
              gap: 2,
              p: { xs: 1.5, sm: 2 },
              minHeight: 64,
              borderRadius: 1,
              borderColor: answered && i === correctIndex ? 'success.main' : 'rgba(36,91,89,0.2)',
            }}
          >
            <Box
              sx={{
                width: 32,
                height: 32,
                borderRadius: '50%',
              backgroundColor: !answered ? 'rgba(36,91,89,0.1)' : 'rgba(255,255,255,.35)',
                color: 'text.primary',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontWeight: 700,
              }}
            >
              {String.fromCharCode(65 + i)}
            </Box>
            <Typography component="span">{opt}</Typography>
          </Button>
        ))}
      </Stack>
      {answered && <><Alert icon={selected === correctIndex ? <CheckCircleOutline fontSize="inherit" /> : <HighlightOff fontSize="inherit" />} severity={selected === correctIndex ? 'success' : 'error'} sx={{ borderRadius: 1 }}>{selected === correctIndex ? 'Dobra odpowiedź. Tak trzymaj!' : 'Poprawna odpowiedź została oznaczona na zielono.'}</Alert><Button onClick={handleNext} variant="contained" endIcon={<ArrowForward />} sx={{ alignSelf: { xs: 'stretch', sm: 'flex-start' }, px: 3 }}>Następne pytanie</Button></>}
    </Stack>
  );
}

export default QuestionCard;
